import axios from 'axios';

const organization_API_HOST = process.env.REACT_APP_API_COMPANY_URL
// const token=localStorage.getItem('Token');
const axiosOrganizationInstance=axios.create({
    baseURL: organization_API_HOST, //"http://127.0.0.1:5000",
    timeout: 20000,
    headers:{
        'Content-Type':"application/json"
        // ''Authorization'': `Bearer ${token}` // Set the token in the 'Authorization' header
        }
    }
);

export default axiosOrganizationInstance;